'use client'

import dayjs from 'dayjs'
import { useTranslations } from '@/lib/next-shim'

import { Box, Paper, Stack, Typography } from '@mui/material'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'

import { useGetMyInfosQuery } from '@/core/graphql/hooks'

import { ReadOnlyField } from './ReadOnlyField'

export function InsIdentitySection() {
  const t = useTranslations()
  const { data } = useGetMyInfosQuery()
  const patient = data?.myInfos
  const userInfo = patient?.userInfo

  const hasAnyInsData =
    !!userInfo?.birthSurname || !!userInfo?.birthName || !!userInfo?.birthPlace || !!userInfo?.birthPlaceCode || !!patient?.insNIR || !!patient?.insOID
  if (!hasAnyInsData) return null

  const fallback = t('page.AccountSettings.profile.insIdentity.notProvided')
  const formattedBirthday = userInfo?.birthday ? dayjs(userInfo.birthday).format('DD/MM/YYYY') : fallback
  const formattedBirthPlace = [userInfo?.birthPlace, userInfo?.birthPlaceCode].filter(Boolean).join(' — ') || fallback

  return (
    <Paper elevation={0} sx={{ borderRadius: 3, p: 4, boxShadow: '0 12px 40px rgba(25,28,29,0.06)' }}>
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <BadgeOutlinedIcon sx={{ color: 'primary.dark' }} />
          <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
            {t('page.AccountSettings.profile.insIdentity.title')}
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {t('page.AccountSettings.profile.insIdentity.subtitle')}
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, columnGap: 3, rowGap: 2 }}>
          <ReadOnlyField label={t('field.birthName.label')} value={userInfo?.birthSurname || fallback} />
          <ReadOnlyField label={t('field.birthFirstNames.label')} value={userInfo?.birthName || fallback} />
          <ReadOnlyField label={t('field.birthDate.label')} value={formattedBirthday} />
          <ReadOnlyField label={t('field.sex.label')} value={userInfo?.gender || fallback} />
          <ReadOnlyField label={t('field.birthPlace.label')} value={formattedBirthPlace} />
          <ReadOnlyField label={t('page.AccountSettings.profile.insIdentity.matricule')} value={patient?.insNIR || fallback} />
          <ReadOnlyField label={t('page.AccountSettings.profile.insIdentity.oid')} value={patient?.insOID || fallback} />
        </Box>
      </Stack>
    </Paper>
  )
}
